module.exports = __webpack_public_path__ + "static/plate_mail-58a6e7aae7131a94e9828c47763ddf22.jpg";